import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { PriorityAPI } from "./../../../apis/PriorityAPI";
import isLoggedIn from "./../../../utils/isLoggedIn";
import userContext from "./../../../context/userContext";
import PriorityItem from "./PriorityItem"
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import AddPriorityForm from "./AddPriorityForm";


const AllPriorities = () => {
    const navigate = useNavigate();
    const { userLoggedIn } = useContext(userContext);
    const [isLoading, setIsLoading] = useState(true)
    const [apiErr, setApiErr] = useState()
    const [allPriorities, setAllPriorities] = useState();
    const [displayAddForm, setDisplayAddForm] = useState(false);


    const getPriorities = () => {
        PriorityAPI.getAllPriorities().then((response) => {
            console.log(response)
            setIsLoading(false)
            setAllPriorities(response.data)
        })
            .catch(() => {
                setIsLoading(false)
                setApiErr("Une erreur est survenue")
            });
    };

    useEffect(
        () => {
            if (userLoggedIn.roles[0] !== "ROLE_ADMIN") navigate("/profil");
            document.title = "Devolie - Les priorités"
            if (!isLoggedIn()) {
                navigate("/");
            } else {
                getPriorities();
            }
        },
        []
    );

    return (
        <>
            <div>
                <div className="header-with-cta">
                    <h2>Les priorités</h2>
                    <button onClick={() => setDisplayAddForm(true)} className="btn btn-primary create-item-btn"><AddOutlinedIcon />Ajouter</button>
                </div>
                <hr />
                {isLoading && (
                    <p className="loading">Chargement...</p>
                )}
                {apiErr && (
                    <p className="loading">Une erreur est survenue.</p>
                )}

                {!isLoading && allPriorities && allPriorities.length > 1 && (
                    <ul>
                        {allPriorities.map(priority => <PriorityItem priority={priority} setAllPriorities={setAllPriorities} />)}
                    </ul>
                )}
                
                {!isLoading && allPriorities && !Array.isArray(allPriorities) && (
                    <ul>
                        <PriorityItem priority={allPriorities} setAllPriorities={setAllPriorities} />
                    </ul>
                )}

            </div>
            {
                displayAddForm && <AddPriorityForm setDisplayAddForm={setDisplayAddForm} setAllPriorities={setAllPriorities} />
            }

        </>
    );
};

export default AllPriorities;